import ordenReducer from './ordenReducer';
import inputReducer from './inputReducer';
import { combineReducers } from 'redux';

export default combineReducers({
    order: ordenReducer,
    inputData: inputReducer
});
